export const STORAGE_KEYS = {
	AUTH_TOKEN: "auth_token",
	AUTH_REFRESH_TOKEN: "auth_refresh_token",
	AUTH_USER: "auth_user",
	USER_DATA: "user_data",
	THEME: "theme",
	LANGUAGE: "language",
	NOTIFICATIONS: "notifications",
	CURRENT_ORG_UUID: "current_organization_uuid",
	HUB_SELECTED_PROFILE: "hub_selected_profile",
	APP_SETTINGS: "hulahoop_app_settings",
	PAGINATION_ITEMS_PER_PAGE: "pagination_items_per_page",
} as const;

export const SESSION_STORAGE_KEYS = {
	AI_AGENT_SESSION_ID: "ai_agent_session_id",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
export type SessionStorageKey =
	(typeof SESSION_STORAGE_KEYS)[keyof typeof SESSION_STORAGE_KEYS];
